import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Radio from "@/components/common/Radio";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { alpha, FormControl, FormControlLabel, RadioGroup, styled, Typography } from "@mui/material";
import { useId } from "react";
import useHandoutProductStore from "src/store/relatedProduct";
const borderColorMap = {
    default: (theme)=>theme.palette.grey[200],
    selected: (theme)=>theme.palette.primary.main,
    disabled: (theme)=>theme.palette.grey[100]
};
const backgroundColorMap = {
    default: (theme)=>theme.palette.common.white,
    selected: (theme)=>theme.palette.indigo[0],
    disabled: (theme)=>theme.palette.grey[50]
};
const labelColorMap = {
    default: "text.primary",
    selected: "indigo.500",
    disabled: "text.disabled"
};
const PurchaseFormControlLabel = styled(FormControlLabel)((param)=>{
    let { theme , status  } = param;
    return {
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
        border: "1px solid",
        padding: theme.spacing(0.5, 1),
        borderRadius: "6px",
        borderColor: borderColorMap[status](theme),
        backgroundColor: backgroundColorMap[status](theme),
        cursor: status === "disabled" ? "not-allowed" : "pointer",
        color: labelColorMap[status],
        "&:hover": {
            backgroundColor: status === "disabled" || status === "selected" ? "none" : alpha(theme.palette.grey[300], 0.2)
        }
    };
});
const getStatusAndColor = (param)=>{
    let { isOptionAvailable , optionType , selectedOption  } = param;
    let status;
    if (isOptionAvailable === "all") {
        status = optionType === selectedOption ? "selected" : "default";
    } else {
        status = isOptionAvailable === optionType ? "selected" : "disabled";
    }
    return {
        status,
        color: labelColorMap[status]
    };
};
const PurchaseOption = ()=>{
    const id = useId();
    const { selectedPurchaseOption , currentProduct , purchaseOption , setSelectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption,
            currentProduct: state.currentProduct,
            purchaseOption: state.purchaseOption,
            setSelectedPurchaseOption: state.setSelectedPurchaseOption
        }));
    const { price , downloadPrice  } = currentProduct;
    const optionToValue = (purchaseOption === null || purchaseOption === void 0 ? void 0 : purchaseOption.length) === 2 ? "all" : purchaseOption[0];
    const handleChange = (e)=>{
        if (!optionToValue) return;
        const statusVal = optionToValue === "all" ? "all" : optionToValue;
        if (statusVal !== "all" && statusVal !== e.target.value) return;
        setSelectedPurchaseOption(e.target.value);
        //mx-208
        mixpanelEvent("Purchase Option Button Clicked", {
            "Button Name": e.target.value
        });
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(FormControl, {
            sx: {
                width: "100%"
            },
            children: /*#__PURE__*/ _jsxs(RadioGroup, {
                value: selectedPurchaseOption,
                onChange: handleChange,
                sx: {
                    flexDirection: "row",
                    gap: "8px",
                    label: {
                        margin: 0,
                        display: "flex"
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx(PurchaseOptionRadio, {
                        optionType: "view",
                        price: price,
                        label: "열람+출력 (대여)",
                        selectedOption: selectedPurchaseOption,
                        isOptionAvailable: optionToValue
                    }),
                    /*#__PURE__*/ _jsx(PurchaseOptionRadio, {
                        optionType: "download",
                        // 다운로드 금액은 price의 무조건 2배 가격입니다. 이 downloadPrice가 없을 수 있어요. 그럴 때는 price의 2배로 계산해주세요. 25.03.20
                        price: downloadPrice !== null && downloadPrice !== void 0 ? downloadPrice : Number(price) * 2,
                        label: "PDF 다운 (소장)",
                        selectedOption: selectedPurchaseOption,
                        isOptionAvailable: optionToValue
                    })
                ]
            })
        })
    });
};
const PurchaseOptionRadio = (param)=>{
    let { optionType , price , label , selectedOption , isOptionAvailable  } = param;
    const { status , color  } = getStatusAndColor({
        isOptionAvailable,
        optionType,
        selectedOption: selectedOption
    });
    return /*#__PURE__*/ _jsx(PurchaseFormControlLabel, {
        status: status,
        value: isOptionAvailable !== "all" ? optionType === isOptionAvailable ? optionType : null : optionType,
        control: /*#__PURE__*/ _jsx(Radio, {
            sx: {
                display: "none"
            }
        }),
        sx: (theme)=>({
                padding: theme.spacing(1)
            }),
        label: /*#__PURE__*/ _jsxs(Typography, {
            sx: {
                width: "100%",
                color: color,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            },
            variant: "subtitle1",
            children: [
                label,
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "caption",
                    sx: {
                        color: status === "disabled" ? "text.disabled" : "text.secondary"
                    },
                    children: isOptionAvailable === "all" || isOptionAvailable === optionType ? price.toLocaleString() + "원" : "미제공자료"
                })
            ]
        })
    });
};
export default PurchaseOption;
